import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Accordion extends Component {
  static propTypes = {
    expanded: PropTypes.bool,
    headerComponent: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
  };

  static defaultProps = {
    expanded: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      expanded: props.expanded,
    };
  }

  toggle = () => {
    this.setState(prevState => ({
      expanded: !prevState.expanded,
    }));
  };

  render() {
    const { expanded } = this.state;
    const { headerComponent, children } = this.props;

    return (
      <div className="accordion-wrapper">
        <button className="accordion-button" type="submit" onClick={() => this.toggle()}>
          {headerComponent(expanded)}
        </button>
        <div
          className={
            expanded ? 'accordion-content accordion-content--actived' : 'accordion-content'
          }
        >
          {children}
        </div>
      </div>
    );
  }
}

export default Accordion;



// WEBPACK FOOTER //
// ./src/components/Accordion.js